<script lang="ts">
	import { getClient, mutate } from 'svelte-apollo';
	import FormField from '@smui/form-field/styled';
	import Radio from '@smui/radio/styled';
	import Button, { Label } from '@smui/button/styled';
	import { createForm } from 'svelte-forms-lib';
	import * as yup from 'yup';
	import { graphQLErrors as graphQLErrorsStore, userInfo } from '../../stores';
	import Dialog, { Title, Content, Actions } from '@smui/dialog/styled';
	import { Link } from 'svelte-routing';
	import { APP_PATHS } from '../../constants';
	import AppContainer from '../../components/AppContainer.svelte';
	import Text from '../../components/Text.svelte';
	import { changeRole } from '../../graphql/queries/users';

	const client = getClient();

	export let email: string;
	export let role: string;

	let errorMessage: string;
	let errorDialog = false;
	let okDialog = false;

	const changeUserOp = (userEmail: string, userRole: string) => {
		return new Promise((resolve) =>
			mutate(client, {
				mutation: changeRole,
				variables: {
					email: userEmail,
					role: userRole
				},
				errorPolicy: 'all'
			})
				.then((dataResponse) => {
					resolve(dataResponse);
				})
				.catch((err) => {
					console.warn(err);
					resolve({ errors: err });
				})
		);
	};

	function handleError(errMsg: string) {
		errorMessage = errMsg;
		errorDialog = true;
		console.error('Error', errMsg);
	}

	const { form, handleSubmit, isValid } = createForm({
		initialValues: {
			userRole: role.toLowerCase()
		},
		validationSchema: yup.object().shape({
			userRole: yup.string().required()
		}),
		onSubmit: async (values) => {
			graphQLErrorsStore.set(undefined);
			return changeUserOp(email, values.userRole)
				.then(() => {
					okDialog = true;
				})
				.catch((err) => {
					handleError(err.message);
				});
		}
	});
</script>

<AppContainer>
	<Text gutter type="headline3">Add new user</Text>

	<div class="description">
		<Text>Please fill user’s e-mail and role for new user</Text>
	</div>

	<form class:valid={$isValid} on:submit={handleSubmit}>
		<Text type="subtitle1">Role:</Text>
		<div>
			<FormField>
				<Radio bind:group={$form.userRole} value={'user'} />
				<span slot="label">User</span>
			</FormField>
			<FormField>
				<Radio bind:group={$form.userRole} value={'admin'} />
				<span slot="label">Admin</span>
			</FormField>
			{#if $userInfo.role === 'SUPERADMIN'}
				<FormField>
					<Radio bind:group={$form.userRole} value={'superadmin'} />
					<span slot="label">Superadmin</span>
				</FormField>
			{/if}
		</div>

		<Button variant="raised" class="add-button" type="submit">
			<Label>Send</Label>
		</Button>
	</form>
</AppContainer>

<Dialog
	open={okDialog}
	aria-labelledby="dialog-title"
	aria-describedby="dialog-content"
	scrimClickAction=""
	escapeKeyAction=""
>
	<Title id="dialog-title">The role for user {email} was sucessfully changed</Title>
	<Content id="dialog-content">
		You can view it in
		<Link to={APP_PATHS.USER_MANAGEMENT}>User management section</Link>.
	</Content>

	<Actions>
		<Button on:click={() => (okDialog = false)}>Close</Button>
	</Actions>
</Dialog>

<Dialog
	open={errorDialog}
	aria-labelledby="dialog-title"
	aria-describedby="dialog-content"
	scrimClickAction=""
	escapeKeyAction=""
>
	<Title id="dialog-title">Error during changing the role of user {email}</Title>
	<Content id="dialog-content">{errorMessage}</Content>

	<Actions>
		<Button on:click={() => (errorDialog = false)}>Close</Button>
	</Actions>
</Dialog>

<style>
	:global(.description) {
		margin-bottom: 35px;
	}

	:global(.add-button) {
		margin-top: 30px;
	}
</style>
